<template>
  <div class>
    <div class="header-banner">
      <Header class="home-header" :isLogin="true" />
      <HeaderM class="home-header-m" :isLogin="true" />
      <Banner :showData="true"/>
    </div>
    <div class="main">
      <MainData />
      <Digitization />
      <SourceMatch ref="sm" :showTab="true"/>
      <NewConstruction ref="ns"/>
      <Wisdom ref="wd"/>
      <DigitizationCloud ref="dc"/>
      <LiveCloud ref="lc"/>
      <ScientificPlatform ref="sp"/>
    </div>
    <Footer :isLogin="true" />
  </div>
</template>

<script>
  /* eslint-disable no-unused-vars */
  // @ is an alias to /src
  import Header from '@/components/Header.vue';
  import HeaderM from '@/components/HeaderM.vue';
  import Footer from '@/components/Footer.vue';
  import Banner from '@/components/main/Banner.vue';
  import Digitization from '@/components/main/Digitization.vue';
  import DigitizationCloud from '@/components/main/DigitizationCloud.vue';
  import LiveCloud from '@/components/main/LiveCloud.vue';
  import MainData from '@/components/main/MainData.vue';
  import NewConstruction from '@/components/main/NewConstruction.vue';
  import ScientificPlatform from '@/components/main/ScientificPlatform.vue';
  import SourceMatch from '@/components/main/SourceMatch.vue';
  import Wisdom from '@/components/main/Wisdom.vue';
  import 'swiper/dist/css/swiper.css';
  import './Home.css';

  import {
    querStatice
  } from '@/api/main.js'

  import {
    getCacheUserInfo,setStaticInfo
  } from '@/utils/auth';
  import {
    mobilecheck
  } from '@/utils/ua'

  export default {
    name: 'Home',
    components: {
      Header,
      HeaderM,
      Footer,
      Banner,
      Digitization,
      DigitizationCloud,
      LiveCloud,
      MainData,
      NewConstruction,
      ScientificPlatform,
      SourceMatch,
      Wisdom,
    },
    beforeMount() {

      // const userInfo = getCacheUserInfo();
      // if (userInfo && userInfo.uid) {
      //   // if (mobilecheck()) {
      //   //     this.$router.push('personal-center/m-mine');
      //   //     return;
      //   // }
      //   // this.$router.push('personal-center/profile');

      // } else {
      //   this.$router.push('login');
      // }
    },
    mounted(){
      this.getAllStatics()
    },
    methods: {
      getAllStatics() {
        this.$http.get(querStatice()).then((res) => {
          if (res.code === 1) {
            setStaticInfo(res.data)
            this.$refs.sm.p_init()
            this.$refs.ns.p_init()
            this.$refs.wd.p_init()
            this.$refs.dc.p_init()
            this.$refs.lc.p_init()
            this.$refs.sp.p_init()
          }
        });
      },
    },

  }
</script>

<style>
  @media screen and (max-width: 850px) {
    .home-header {
      display: none !important;
    }

    .home-header-m {
      display: block;
    }
  }
</style>
